import api, { Command } from '../api';
import BaseStore from './base';
import person from './person';
export class CoursesStore extends BaseStore {
    constructor() {
        super({
            list: [],
            loading: false,
            total: -1,
            courses: {},
            lectures: {},
        });
    }
    async init() {
        const { total, loading } = this.get();
        if (total === -1 && !loading) {
            await this.loadCourses();
            person.init();
        }
    }
    /**
     * Загрузка следующей порции списка курсов, если это необходимо
     */
    async loadCourses(amount = 200) {
        const { list, total } = this.get();
        if (total === -1 || list.length < total) {
            this.update({ loading: true });
            try {
                const l = amount;
                const p = Math.floor(list.length / l);
                const { courses, paging } = await api.get(Command.CourseList, { p, l });
                console.log('loaded', courses, paging);
                this.updateCourseList(courses);
                this.update({ total: paging.countAll });
            }
            finally {
                this.update({ loading: false });
            }
        }
    }
    /**
     * Выделяет указанный курс
     */
    async selectCourse(id) {
        console.log('select course', id);
        if (!id) {
            this.update({ selectedCourse: undefined });
        }
        else {
            this.update({ selectedCourse: id });
            // Проверим, нужно ли загрузить данные о лекциях
            const { courses, lectures } = this.get();
            const course = courses[id];
            const loaded = course === null || course === void 0 ? void 0 : course.lectures.every(ref => lectures[ref.id]);
            if (!loaded) {
                const resp = await this.load(id, () => api.get(Command.Course, { id }));
                const nextLectures = Object.assign({}, lectures);
                resp.course.lectures.forEach(lecture => {
                    nextLectures[lecture.id] = lecture;
                });
                console.log('set lectures', nextLectures);
                this.update({ lectures: nextLectures });
            }
        }
    }
    /**
     * Обновление данных курса
     */
    async updateCourse(data) {
        if (data.id) {
            this.update({ progress: 'course' });
            try {
                const resp = await this.load(data.id, () => api.put(Command.Course, data));
                const { courses } = this.get();
                this.update({
                    courses: Object.assign(Object.assign({}, courses), { [data.id]: resp.course })
                });
            }
            catch (err) {
                console.error(err);
            }
            finally {
                this.update({ progress: null });
            }
        }
    }
    async selectLecture(id) {
        if (!id) {
            this.update({ selectedLecture: undefined });
        }
        else {
            this.update({ selectedLecture: id });
        }
    }
    async updateLecture(data) {
        if (data.id) {
            this.update({ progress: 'lecture' });
            try {
                // TODO учитывать файлы
                const resp = await this.load(data.id, () => api.put(Command.Lecture, data));
                const { lectures } = this.get();
                this.update({
                    lectures: Object.assign(Object.assign({}, lectures), { [data.id]: resp.lecture })
                });
            }
            catch (err) {
                console.error(err);
            }
            finally {
                this.update({ progress: null });
            }
        }
    }
    resetError() {
        this.update({ error: undefined });
    }
    updateCourseList(data) {
        let { list, courses } = this.get();
        list = [...list];
        courses = Object.assign({}, courses);
        const lookup = new Set(list.map(item => item.id));
        data.forEach(course => {
            courses[course.id] = course;
            if (!lookup.has(course.id)) {
                list.push({ id: course.id });
                lookup.add(course.id);
            }
        });
        this.update({ list, courses });
    }
    /**
     * Обёртка для загрузки данных с индикацией загрузки в модели
     */
    load(id, cb) {
        try {
            this.update({ loading: id });
            return cb();
        }
        catch (error) {
            this.update({ error });
            throw error;
        }
        finally {
            const { loading } = this.get();
            if (loading === id) {
                this.update({ loading: false });
            }
        }
    }
}
const store = new CoursesStore();
export default store;
